export default __webpack_public_path__ + "static/media/room2_02.80519b67.png";